/* eslint-disable @typescript-eslint/naming-convention */
import { get } from 'lodash';

import { languages } from '@core/lib/constants/languages';
import { User, Account, PendoTrackEventMetadata } from '@core/api/types';

export const startTracking = (user: User, account: Account) => {
  if (!get(window, 'pendo')) {
    return;
  }

  pendo.initialize({
    visitor: {
      id: user.id.toString(),
      email: user.email,
      full_name: user.full_name || '',
      role: user.role,
      timezone_id: user.timezone_id || '',
      language: user.language,
      locale: languages.find(item => item.id === user.language)?.id || 'en',
      creationDate: user.created_at,
      country: user.country || '',
      region: user.region || '',
    },

    account: {
      id: account.id.toString(),
      name: account.name,
      is_paying: true,
      monthly_value: account.payment_plan?.base_price ?? '',
      planLevel: account.payment_plan?.name ?? '',
      planPrice: account.payment_plan?.attribution_price ?? '',
      creationDate: account.created_at,
      status: account.state,
      manager: account.manager || '',
      sales_manager: account.sales_manager || '',
      billing_day: account.billing_day,
      contract_length: account.contract_length || '',
      contract_ends_on: account.contract_ends_on || '',
    },
  });
};

export const trackCustomEvent = (user: Nullable<User>, event: string, metadata?: PendoTrackEventMetadata) => {
  if (!get(window, 'pendo') || user?.super_admin || user?.email.endsWith('adjust.com')) {
    return;
  }

  pendo.track(event, metadata);
};

export default {
  startTracking,
};
